import { render, staticRenderFns } from "./deactivate-event-modal.vue?vue&type=template&id=63d1495a"
import script from "./deactivate-event-modal.vue?vue&type=script&lang=ts"
export * from "./deactivate-event-modal.vue?vue&type=script&lang=ts"
import style0 from "./deactivate-event-modal.vue?vue&type=style&index=0&id=63d1495a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports